<form class="form-container" [formGroup]="feedbackForm" (ngSubmit)="onSubmit()">
  <div class="title-container">
    <div class="title">{{ 'WebApp.v1.Survey.SurveyFeedback.Title' | translate }}</div>
    <div class="description">{{ 'WebApp.v1.Survey.SurveyFeedback.Description' | translate }}</div>
  </div>

  <div class="select-container" [class.expanded]="isDropdownOpen()">
    <div class="select">
      <div class="select-header" [class.selected]="!!isDropdownOpen()" (click)="toggleDropdown()">
        <div class="select-box single">
          <div class="select-box-title">{{ 'WebApp.v1.Survey.SurveyFeedback.From' | translate }}:</div>
          @if (isDropdownOpen()) {
            <div class="dropdown-options">
              @for (sender of senders; track sender) {
                <div class="dropdown-option">
                  <app-checkbox
                    class="select-box-checkbox"
                    [checkSize]="20"
                    checkColor="#56FA98"
                    checkBackgroundColor="transparent"
                    checkBorderColor="#FFF"
                    [checked]="sender === selectedSender"
                    (checkboxClick)="selectSender()"
                  >
                    <div class="sender-name" [class.selected]="sender === selectedSender">{{ sender }}</div>
                  </app-checkbox>
                </div>
              }
            </div>
          } @else {
            <app-checkbox
              class="select-box-checkbox"
              [checkSize]="20"
              checkColor="#56FA98"
              checkBackgroundColor="transparent"
              checkBorderColor="#FFF"
              [checked]="true"
              (checkboxClick)="selectSender()"
            >
              <div
                class="select-box-name"
                [class.selected]="senderChecked"
              >{{ isDropdownOpen() ? senders[0] : selectedSender }}</div>
            </app-checkbox>
          }
        </div>

        <div class="select-icon">
          <i
            class="fa"
            [class.fa-chevron-down]="!isDropdownOpen()"
            [class.fa-chevron-up]="isDropdownOpen()"
          ></i>
        </div>
      </div>
    </div>

    <div class="select">
      <div
        class="select-header"
        [class.selected-boxs]="!!isRecipientsDropdownOpen()"
        (click)="toggleRecipientsDropdown()"
      >
        <div class="select-box">
          <div class="select-box-title">{{ 'WebApp.v1.Survey.SurveyFeedback.Recipient' | translate }}:</div>
  
          @if (isRecipientsDropdownOpen()) {
            <div class="select-box-list">
              @if (!!recipients && recipients.managerRecipients.length > 0) {
                <div class="select-box-list-title">{{ 'WebApp.v1.Survey.SurveyFeedback.MyManagers' | translate }}</div>

                @for (recipient of recipients.managerRecipients; track recipient.userId) {
                    <app-checkbox
                      class="select-box-checkbox"
                      [checkSize]="20"
                      checkColor="#56FA98"
                      checkBackgroundColor="transparent"
                      checkBorderColor="#FFF"
                      [checked]="isRecipientSelected(recipient)"
                      (checkboxClick)="toggleRecipient(recipient)"
                    >
                      <div
                        class="recipient-name"
                        [class.selected]="isRecipientSelected(recipient)"
                      >{{ recipient.fullName }}</div>
                    </app-checkbox>
                }
              } @if (!!recipients && !!recipients.hrRecipients) {
                <div class="select-box-list-title">{{ 'WebApp.v1.Survey.SurveyFeedback.Administrators' | translate }}</div>

                @for (recipient of recipients.hrRecipients; track recipient.userId) {
                  <app-checkbox
                    class="select-box-checkbox"
                    [checkSize]="20"
                    checkColor="#56FA98"
                    checkBackgroundColor="transparent"
                    checkBorderColor="#FFF"
                    [checked]="isRecipientSelected(recipient)"
                    (checkboxClick)="toggleRecipient(recipient)"
                  >
                    <div
                      class="recipient-name"
                      [class.selected]="isRecipientSelected(recipient)"
                    >{{ recipient.fullName }}</div>
                  </app-checkbox>
                }
              }
            </div>
          } @else {
            <div class="selected-boxs">{{ selectedRecipientsNames }}</div>
          }
        </div>

        <div class="select-recipient-icon" [class.down]="!isRecipientsDropdownOpen()">
          <i
            class="fa"
            [class.fa-chevron-down]="!isRecipientsDropdownOpen()"
            [class.fa-chevron-up]="isRecipientsDropdownOpen()"
          ></i>
        </div>
      </div>
    </div>
  </div>

  <div class="textarea-container">
    <textarea
      class="textarea"
      placeholder="{{ 'WebApp.v1.Survey.SurveyFeedback.MessagePlaceholder' | translate }}"
      formControlName="message"
    ></textarea>

    <div class="overlay" [class.visible]="isMessageSent()">
      <div class="overlay-content">
        <div class="overlay-title">{{ 'WebApp.v1.Survey.SurveyFeedback.MessageSent' | translate }}</div>
        <i class="overlay-icon fa-solid fa-check"></i>
      </div>
    </div>
  </div>

  <div class="button-container" [class.hidden]="isMessageSent()">
    <app-button
      class="button"
      [label]="'WebApp.v1.Shared.Buttons.SendMessage' | translate"
      backgroundColor="#2CDAFF"
      [fontSize]="16"
      type="submit"
      [disabled]="!feedbackForm.valid"
    ></app-button>
    <div
      class="skip"
      [class.disabled]="disabled"
      (click)="onSkipFeedback()"
    >
      {{ 'WebApp.v1.Survey.SkipStep' | translate }}
      <i class="fa fa-chevron-right fa-xl"></i>
    </div>
  </div>
</form>

